import gql from 'graphql-tag'

export const CREATE_SAVED_SEARCH_MUTATION = gql`
  mutation CreateSavedSearch(
    $city: String!
    $state: String!
    $latitude: Float!
    $longitude: Float!
  ) {
    saveSearch(city: $city, state: $state, latitude: $latitude, longitude: $longitude) {
      city
      state
      longitude
      latitude
    }
  }
`
